import {
	AnalyticsEventModel,
	registerAnalytics
} from "client/Api/Analytics/analytics";
import { analyticsStore } from "./analyticsStore";

class Analytics {
	private readonly _interval: SetIntervalHandle;
	private readonly _boundBeforeunload: () => void;

	constructor() {
		const delay: number = (1000 * 60) * 5;
		this._interval = setInterval(
			() => this.register(),
			delay
		);

		this._boundBeforeunload = this.beforeunload.bind(this);

		window.addEventListener(
			"beforeunload",
			this._boundBeforeunload
		);
	}

	private async register(): Promise<void> {
		const events: readonly AnalyticsEventModel[] = analyticsStore
			.getState()
			.events;

		if (events.length === 0) {
			return;
		}

		try {
			await registerAnalytics(events);

			analyticsStore
				.getState()
				.emptyEvents();
		} catch (e) {
			console.error(e);
		}
	}

	private beforeunload(): void {
		this.register();
		this.terminate();
	}

	public terminate(): void {
		if (this._interval) {
			clearInterval(this._interval);
		}

		window.removeEventListener(
			"beforeunload",
			this._boundBeforeunload
		);
	}
}

export function init(): void {
	new Analytics();
}